<div
  *ngIf="show"
  [ngClass]="{ 'absolute absolute -top-1 right-[5%] z-50': !inline }"
  class="w-[0.5rem] h-[0.5rem] rounded-[100vmax] bg-notification outline outline-[1.5px] outline-solid outline-[var(--notification-outline-color)] transition-colors"
></div>
